<template>
    <div id="periode-form">
        <v-card text>
            <!-- Nama Periode -->
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Nama Periode *
                    </v-list-item-title>
                    <v-text-field id="periode_name" ref="name" placeholder="Nama Periode" :rules="nameRules"
                        v-model="periode.name" outlined />
                </v-list-item-content>
            </v-list-item>

            <!-- Deskripsi -->
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Deskripsi
                    </v-list-item-title>
                    <v-textarea id="periode_deskripsi" ref="description" placeholder="Deskripsi Periode"
                        :rules="descriptionRules" v-model="periode.description" outlined />
                </v-list-item-content>
            </v-list-item>

            <!-- Waktu -->
            <v-list-item class="pa-0">
                <v-row>
                    <!-- Start Date -->
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold pb-2">
                                    Waktu Mulai *
                                </v-list-item-title>
                                <v-menu v-model="menuStart" :close-on-content-click="false"
                                    transition="slide-y-reverse-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field id="periode_start_date" v-model="periode.start_date"
                                            append-icon="mdi-calendar" placeholder="Tanggal" v-bind="attrs" v-on="on"
                                            outlined readonly></v-text-field>
                                    </template>
                                    <v-date-picker v-model="periode.start_date" no-title scrollable
                                        @change="menuStart = false" />
                                </v-menu>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>

                    <!-- End Date -->
                    <v-col cols="6">
                        <v-list-item two-line class="py-0 px-1">
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold pb-2">
                                    Waktu Berakhir *
                                </v-list-item-title>
                                <v-menu v-model="menuEnd" :close-on-content-click="false"
                                    transition="slide-y-reverse-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field id="periode_end_date" v-model="periode.end_date"
                                            append-icon="mdi-calendar" placeholder="Tanggal" v-bind="attrs" v-on="on"
                                            outlined readonly></v-text-field>
                                    </template>
                                    <v-date-picker v-model="periode.end_date" no-title scrollable
                                        @change="menuEnd = false" />
                                </v-menu>
                            </v-list-item-content>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-list-item>

            <!-- Actions -->
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn id="periode_simpan" color="blew" @click="submit" depressed dark>
                    Selanjutnya
                </v-btn>
            </v-card-actions>
        </v-card>

        <app-spinner v-if="isLoading" />
    </div>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";

export default {
    name: "periode-form",
    components: { "app-spinner": Spinner },

    data() {
        return {
            isLoading: false,
            menuStart: false,
            menuEnd: false,
            nameRules: [(v) => (v || "").length <= 100 || "Maksimal 100 karakter"],
            descriptionRules: [(v) => (v || "").length <= 255 || "Maksimal 255 karakter"],
            periode: {
                id: 0,
                name: "",
                description: "",
                start_date: "", // always ISO string YYYY-MM-DD
                end_date: "",   // always ISO string YYYY-MM-DD
                is_active: false,
            }
        };
    },

    mounted() {
        if (this.$store.state.ambismeter.id > 0) {
            this.periode = {
                ...this.$store.state.ambismeter,
                start_date: this.$store.state.ambismeter.start_date || this.today(),
                end_date: this.$store.state.ambismeter.end_date || this.today(),
            };
        } else {
            this.periode.start_date = this.today();
            this.periode.end_date = this.today();
        }
    },

    methods: {
        today() {
            const d = new Date();
            return d.toISOString().substring(0, 10); // YYYY-MM-DD
        },

        submit() {
            if (!this.validateForm()) {
                window.scrollTo(0, 0);
                return;
            }

            const params = {
                ...this.periode,
                start_date: this.formatForBackend(this.periode.start_date),
                end_date: this.formatForBackend(this.periode.end_date),
            };

            this.isLoading = true;

            if (!this.$route.query.id) {
                // create
                AmbisMeterService.addPeriode(params, (result) => {
                    this.isLoading = false;
                    if (result.success && result.data && result.data.id) {
                        this.storePeriodeAndComplete(result.data);
                    } else {
                        this.showError(result);
                    }
                });

                AmbisMeterService.updatePeriode(this.$route.query.id, params, (result) => {
                    this.isLoading = false;
                    if (result.success && result.data && result.data.id) {
                        this.storePeriodeAndComplete(result.data);
                    } else {
                        this.showError(result);
                    }
                });
            }
        },

        formatForBackend(date) {
            if (!date) return "";
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();
            return `${day}/${month}/${year}`;
        },

        storePeriodeAndComplete(data) {
            this.$store.commit("periode_init", data);
            this.$store.commit("showAlert", {
                message: `Periode telah berhasil disimpan!`,
                type: "success",
            });
            this.$emit("completed");
        },

        showError(result) {
            const desc = result && result.data ? result.data.description : null;

            if (desc && desc.includes("Periode That Have A Same Start Date Already Exist")) {
                this.$store.commit("showAlert", {
                    message: "Periode dengan Waktu Mulai yang sama sudah ada!",
                    type: "error",
                });
            } else {
                this.$store.commit("showAlert", {
                    message: "Gagal menyimpan periode!",
                    type: "error",
                });
            }
        },

        validateForm() {
            let errors = false;
            if (!this.periode.name) {
                this.$store.commit("showAlert", {
                    message: "Nama Periode!",
                    submessage: "Nama wajib diisi!",
                    type: "error",
                });
                errors = true;
            } else if (!this.periode.start_date) {
                this.$store.commit("showAlert", {
                    message: "Waktu Mulai!",
                    submessage: "Waktu Mulai wajib diisi!",
                    type: "error",
                });
                errors = true;
            } else if (!this.periode.end_date) {
                this.$store.commit("showAlert", {
                    message: "Waktu Berakhir!",
                    submessage: "Waktu Berakhir wajib diisi!",
                    type: "error",
                });
                errors = true;
            } else if (!this.$refs.name.validate()) {
                this.$store.commit("showAlert", {
                    message: "Nama melebihi maksimal karakter!",
                    type: "error",
                });
                errors = true;
            } else if (!this.$refs.description.validate()) {
                this.$store.commit("showAlert", {
                    message: "Deskripsi melebihi maksimal karakter!",
                    type: "error",
                });
                errors = true;
            }

            // prevent start_date in past when creating
            if (!this.$route.query.id && this.periode.start_date < this.today()) {
                this.$store.commit("showAlert", {
                    message: "Waktu Mulai!",
                    submessage: "Tanggal mulai sudah lewat!",
                    type: "error",
                });
                errors = true;
            }

            return !errors;
        }
    }
};
</script>



// WEBPACK FOOTER //
// PeriodeForm.vue?218eea7c